"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateQuoteDto = exports.CreateQuoteDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class DocumentDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Document ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], DocumentDto.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Document type must be a number." }),
    tslib_1.__metadata("design:type", Number)
], DocumentDto.prototype, "documentTypeLid", void 0);
class UpdateQuoteDocumentsDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdateQuoteDocumentsDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Document ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateQuoteDocumentsDto.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Document type must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateQuoteDocumentsDto.prototype, "documentTypeLid", void 0);
class QuoteTaxDetailDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Tax is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Tax must be a number." }),
    tslib_1.__metadata("design:type", Number)
], QuoteTaxDetailDto.prototype, "tax", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Tax value is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Tax Value must be a number." }),
    tslib_1.__metadata("design:type", Number)
], QuoteTaxDetailDto.prototype, "taxValue", void 0);
class RemarksSectionDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string." }),
    tslib_1.__metadata("design:type", String)
], RemarksSectionDto.prototype, "remarks", void 0);
class QuoteDetailsDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Insurer ID is required." }),
    (0, class_validator_1.IsNumber)({}, { message: "Insurer ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], QuoteDetailsDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)({}, { message: "Quote Received On must be a valid date string." }),
    tslib_1.__metadata("design:type", String)
], QuoteDetailsDto.prototype, "quoteReceivedOn", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Basic Premium must be a number." }),
    tslib_1.__metadata("design:type", Number)
], QuoteDetailsDto.prototype, "basicPremium", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Terrorism Cover must be a number." }),
    tslib_1.__metadata("design:type", Number)
], QuoteDetailsDto.prototype, "terrorismCover", void 0);
class NetPremiumDetailsDto {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Net Premium must be a number." }),
    tslib_1.__metadata("design:type", Number)
], NetPremiumDetailsDto.prototype, "netPremium", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Brokerage Percent must be a number." }),
    tslib_1.__metadata("design:type", Number)
], NetPremiumDetailsDto.prototype, "brokeragePercent", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Insurer Remarks must be a string." }),
    tslib_1.__metadata("design:type", String)
], NetPremiumDetailsDto.prototype, "insurerRemarks", void 0);
class CreateQuoteDto {
}
exports.CreateQuoteDto = CreateQuoteDto;
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity ID is required." }),
    (0, class_validator_1.IsNumber)({}, { message: "Opportunity ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity Activity ID is required." }),
    (0, class_validator_1.IsNumber)({}, { message: "Opportunity Activity ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Broking Slip ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteDto.prototype, "brokingSlipId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => QuoteDetailsDto),
    tslib_1.__metadata("design:type", QuoteDetailsDto)
], CreateQuoteDto.prototype, "quoteDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Tax details must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => QuoteTaxDetailDto),
    tslib_1.__metadata("design:type", Array)
], CreateQuoteDto.prototype, "taxDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => NetPremiumDetailsDto),
    tslib_1.__metadata("design:type", NetPremiumDetailsDto)
], CreateQuoteDto.prototype, "netPremiumDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Attachment URL must be a string." }),
    tslib_1.__metadata("design:type", String)
], CreateQuoteDto.prototype, "attachmentUrl", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Status ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteDto.prototype, "statusId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Created By must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Updated By must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => DocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreateQuoteDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)({ message: "Covers must be an object." }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], CreateQuoteDto.prototype, "covers", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreateQuoteDto.prototype, "mainDocuments", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => RemarksSectionDto),
    tslib_1.__metadata("design:type", RemarksSectionDto)
], CreateQuoteDto.prototype, "remarksSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Quote status must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteDto.prototype, "quoteStatusLid", void 0);
class UpdateQuoteDto {
}
exports.UpdateQuoteDto = UpdateQuoteDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => UpdateQuoteDocumentsDto),
    tslib_1.__metadata("design:type", Array)
], UpdateQuoteDto.prototype, "mainDocuments", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => RemarksSectionDto),
    tslib_1.__metadata("design:type", RemarksSectionDto)
], UpdateQuoteDto.prototype, "remarksSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Quote status is required." }),
    (0, class_validator_1.IsNumber)({}, { message: "Quote status must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateQuoteDto.prototype, "quoteStatusLid", void 0);
